<template>
  <div>
    <div class="back" @click="back"></div>

    <div class="login-from">
      <div class="title" style="margin-bottom:0.4rem">密码重置</div>

      <div class="login-row" style="justify-content: space-between;padding:0.26rem 0.1rem ">
        <input type="text" v-model="sumbitForm.phone" placeholder="输入登录账号">
        <div class="send-box" v-if="timer"> {{timeNum}}秒后可重发 </div>
        <div class="send-box" v-else @click="getImgCode">发送验证码</div>
      </div>
      <div class="login-row" style="    justify-content: space-between;padding:0.26rem 0.1rem ">
        <input type="text" v-model="sumbitForm.yzm" placeholder="输入验证码">
      </div>
      <div class="login-row" style="    justify-content: space-between;padding:0.26rem 0.1rem ">
        <input :type="EyeValue == '1'  ? 'password' : 'text' " v-model="sumbitForm.password" placeholder="输入新密码">

        <van-icon @click="openEye(2)" v-if="EyeValue == 1" name="closed-eye" />
        <van-icon @click="openEye(1)" v-else name="eye-o" />
      </div>
      <div style="color:#ef4224;font-size:0.24rem;margin-top:0.1rem">密码需包含大小写英文字母数字和特殊字符</div>

      <div class="login-btn" style="width:90%" @click="sumbit">提交</div>
    </div>

    <van-popup v-model:show="isShow" :style="{ padding: '30px 10px 10px',width: '80%', top:'40%'}" closeable>
      <div style="text-align:center">

        <img v-if="sumbitForm.imageBase" @click="getImgCode" :src="sumbitForm.imageBase" alt="">
        <div class="login-row" style="justify-content: space-between;padding:0.26rem 0.1rem ">
          <input type="text" v-model="sumbitForm.tuxingyzm" placeholder="请录入图形验证码">
        </div>
        <div class="send-box border" @click="sendCode">确认</div>

      </div>
    </van-popup>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import request, { baseURL } from '@/utils/request'
import { showToast } from 'vant'
export default {
  setup () {
    let router = useRouter()
    let isShow = ref(false)
    let timeNum = ref(60)
    let timer = ref(false)
    let activeIndex = ref(0)
    let EyeValue = ref(1)
    const openEye = (val)=>{
      EyeValue.value = val
    }


    let sumbitForm = ref({
      yzm: '',//手机验证码
      phone: '',
      imageBase: '',// 图片文件
      tuxingcode: '', // 图形code
      tuxingyzm: '', //图片验证码
      password: '',
    })

    const back = () => {
      router.go(-1)
    }

    const getImgCode = async () => {
      if (sumbitForm.value.phone.length != 11) return showToast('请录入手机号正确的手机号')

      const res = await request({ url: "/login/captcha" })
      isShow.value = true
      sumbitForm.value.imageBase = res.data.image
      sumbitForm.value.tuxingcode = res.data.tuxingcode
    }
    const sendCode = async () => {
      if (sumbitForm.value.phone.length != 11) return showToast('请录入手机号正确的手机号')
      if(!sumbitForm.value.tuxingyzm) return showToast('请录入图形验证码')
      const res = await request({ url: '/login/sendSmsToPhone', method: "post", data: sumbitForm.value })
      console.log('res', res);
      if (res.errorcode == 0) {
        showToast('验证码已成功发送至 '+res.data.email)
        timer.value = setInterval(() => {
          if (timeNum.value <= 1) {
            clearInterval(timer.value)
            timer.value = false
            timeNum.value = 60
            return
          }
          timeNum.value -= 1
        }, 1000);

        isShow.value = false
      } else {
        showToast(res.errormsg)
        sumbitForm.value.tuxingyzm = ''
        getImgCode()
      }

    }



    const sumbit = () => {
      if (sumbitForm.value.phone.length != 11) return showToast('请录入手机号正确的手机号')
      if (!sumbitForm.value.yzm) return showToast('请录入手机验证码')
      console.log(sumbitForm.value);
      let data = {
        phone: sumbitForm.value.phone,
        yzm: sumbitForm.value.yzm,
        password: sumbitForm.value.password,
      }
      request({
        url: "/login/modifyUserPassword",
        method: 'post',
        data
      }).then(res => {
        if (res.errorcode == 0) {
          showToast('修改成功')
          router.go(-1)
        } else {
          showToast(res.errormsg)
        }
      })
    }

    onMounted(() => {
      document.title = '密码重置'
    })

    watch(isShow, val => !val && (sumbitForm.value.tuxingyzm = ''))


    return {
      activeIndex,
      sumbitForm,
      back,
      sendCode, getImgCode, timer, timeNum,
      isShow,
      sumbit,EyeValue,openEye
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/styles/login.less");

.back {
  width: 0.24rem /* 20/50 */;
  height: 0.24rem;
  border-top: 3px solid #e7524a;
  border-left: 3px solid #e7524a;
  transform: rotate(-45deg);
  margin-top: 0.4rem /* 20/50 */;
  margin-left: 0.4rem;
}
.code-box {
  width: 1.5rem /* 50/50 */;
  height: 0.75rem /* 30/50 */;
  border: 1px solid #000;
}
.title {
  font-weight: bold;
  font-size: 0.4rem /* 20/50 */;
  color: rgba(16, 16, 16, 1);
  margin-top: 0.6rem /* 20/50 */;
  margin-bottom: 0.1rem;
}
.tip {
  margin-bottom: 0.6rem /* 20/50 */;
}

.send-box {
  color: #e74e46;
  font-size: 0.26rem /* 13/50 */;
  &.border {
    background-color: #e7524a;
    padding: 0.1rem /* 5/50 */ 0.2rem;
    color: #fff;
    padding: 0.15rem 0;
    margin-top: 0.2rem /* 10/50 */;
  }
}
</style>
